export const overlayButtonSx = {
  '&:hover': {
    transform: 'translateY(-2px)',
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
  transition: 'transform 0.2s ease, background-color 0.2s ease',
};
